import React from 'react'
import { Container, Image } from 'react-bootstrap'
import Slider from 'react-slick'
import inspired1 from "../../assets/images/inspired/1.png" 
import inspired2 from "../../assets/images/inspired/2.png" 
import inspired3 from "../../assets/images/inspired/3.png" 
import inspired4 from "../../assets/images/inspired/4.png"
import "./getInspired.css"
import instaIcon from "../../assets/images/social-icons/insta-icon.png"
const GetInspired = () => {
    const settings = {
        className: "center",
        centerMode: true,
        infinite: true,
        centerPadding: "120px",
        slidesToShow: 4,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 3000,
        cssEase: "linear"
    };
    return (
        <section className='get-inspired'>
            <Container fluid className='p-0'>
                <div className='heading-sec text-center mb-5'>
                    <h2 className='h2'>Get Inspired</h2>
                </div>
                <div className="slider-container">
                    <Slider {...settings}>
                        <div className='slide-wrapper position-relative'>
                            <div className='img-wrapper'>
                                <Image src={inspired1} alt='inspired img' fluid />
                            </div>
                            <div className='insta-icon' role='button'>
                                <Image src={instaIcon} alt='intagram icon' /> 
                            </div>
                        </div>
                        <div className='slide-wrapper position-relative'>
                            <div className='img-wrapper'>
                                <Image src={inspired2} alt='inspired img' fluid />
                            </div>
                            <div className='insta-icon' role='button'>
                                <Image src={instaIcon} alt='intagram icon' /> 
                            </div>
                        </div>
                        <div className='slide-wrapper position-relative'>
                            <div className='img-wrapper'>
                                <Image src={inspired3} alt='inspired img' fluid />
                            </div>
                            <div className='insta-icon' role='button'>
                                <Image src={instaIcon} alt='intagram icon' /> 
                            </div>
                        </div>
                        <div className='slide-wrapper position-relative'>
                            <div className='img-wrapper'>
                                <Image src={inspired4} alt='inspired img' fluid />
                            </div>
                            <div className='insta-icon' role='button'>
                                <Image src={instaIcon} alt='intagram icon' /> 
                            </div>
                        </div>
                        <div className='slide-wrapper position-relative'>
                            <div className='img-wrapper'>
                                <Image src={inspired1} alt='inspired img' fluid />
                            </div>
                            <div className='insta-icon' role='button'>
                                <Image src={instaIcon} alt='intagram icon' /> 
                            </div>
                        </div>
                        <div className='slide-wrapper position-relative'>
                            <div className='img-wrapper'>
                                <Image src={inspired2} alt='inspired img' fluid />
                            </div>
                            <div className='insta-icon' role='button'>
                                <Image src={instaIcon} alt='intagram icon' /> 
                            </div>
                        </div>
                        <div className='slide-wrapper position-relative'>
                            <div className='img-wrapper'>
                                <Image src={inspired3} alt='inspired img' fluid />
                            </div>
                            <div className='insta-icon' role='button'>
                                <Image src={instaIcon} alt='intagram icon' /> 
                            </div>
                        </div>
                    </Slider>
                </div>
            </Container>
        </section>
    )
}

export default GetInspired